import axios from "axios";
import { getPublicApiBaseUrl } from "../config/apiBase";

/** No auth header — customer token is in the URL path. */
const publicQuotationApi = axios.create({
  baseURL: getPublicApiBaseUrl(),
  headers: { "Content-Type": "application/json" },
});

export function startPublicQuotation() {
  return publicQuotationApi.post("quotations/start");
}

export function getPublicQuotation(token) {
  return publicQuotationApi.get(`quotations/${encodeURIComponent(token)}`);
}

export function patchPublicQuotation(token, body) {
  return publicQuotationApi.put(`quotations/${encodeURIComponent(token)}`, body);
}

export function submitPublicQuotation(token) {
  return publicQuotationApi.post(`quotations/${encodeURIComponent(token)}/submit`);
}

export default publicQuotationApi;
